import { createApp } from 'vue';
import App from './App.vue';
import router from './router/app';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import gr from "./locales/gr.json";
import mitt from 'mitt';
import contentReadyMixin from "./mixins/contentReadyMixin";


// show preload in navigation
window.showLoader = () => {
  const loader = document.getElementById('preloader');
  if (loader) loader.classList.add('show');
};

window.hideLoader = () => {
  const loader = document.getElementById('preloader');
  if (loader) loader.classList.remove('show');
};


const i18n = createI18n({
  legacy: false,
  locale: "en",
  messages: { en, gr }
});
const app = createApp(App);

// Register global mixin
app.mixin(contentReadyMixin);

// Global event bus for content-ready notifications
app.config.globalProperties.$emitter = mitt();
app.config.globalProperties.$onContentReady = (callback) => {
  app.config.globalProperties.$emitter.on('content-ready', callback);
};
app.config.globalProperties.$emitContentReady = () => {
  app.config.globalProperties.$emitter.emit('content-ready', () => {});
};

// Use Vue Router
app.use(router);
app.use(i18n);

// Mount the application
app.mount('#app');